<ion-card>
  <ion-card-header>
    <ion-card-title>Csoport-import</ion-card-title>
    <ion-card-subtitle>„Csoportok minden adata" lista beolvasása — átnevezéssel, az órarend megtartásával</ion-card-subtitle>
  </ion-card-header>

  <ion-card-content>
    <ion-note color="medium" class="ic-bevezeto">
      A <b>tagság-import</b> csak azt a csoportot ismeri, amibe már jár valaki — az üres
      (jellemzően fakultációs) csoport onnan sosem keletkezne meg. Ez a törzsfájl viszont
      mindet tartalmazza, és kettőt olyat is tud, amit a tagsági lista nem: az
      <b>osztálybontást</b> (ebből lesz az osztálykötés, és ettől kap névsort a csoport
      akkor is, ha egyesével senkit nem soroltak be) és a <b>csoporttípust</b> (a
      felzárkóztató és a tehetséggondozó foglalkozás, nem tanóra — onnan a hiányzás nem
      tanórai hiányzás).
    </ion-note>

    <!-- 1. Fájl -->
    <div class="ic-lepes">
      <h3><span class="ic-szam">1</span> Fájl</h3>
      <input #fajlValaszto type="file" accept=".xlsx,.xls,.csv" hidden (change)="fajlValtozott($event)" />
      <div class="ic-fajlsor">
        <ion-button size="default" fill="outline" (click)="fajlValaszto.click()">
          <ion-icon slot="start" name="document-attach-outline"></ion-icon>
          {{ fajlNev ? 'Másik fájl' : 'Fájl kiválasztása' }}
        </ion-button>
        <span class="ic-fajl" *ngIf="fajlNev">{{ fajlNev }} — <b>{{ nyersSorok.length }}</b> sor</span>
        <span class="ic-fajl halvany" *ngIf="!fajlNev">Excel (.xlsx/.xls) vagy CSV</span>
      </div>
    </div>

    <!-- 2. Oszlopok -->
    <div class="ic-lepes" *ngIf="fejlecek.length">
      <h3><span class="ic-szam">2</span> Melyik oszlop mit jelent?</h3>
      <ion-note color="medium" class="ic-sugo">
        Csak a <b>csoportnév</b> kötelező. Az osztálybontás nélkül a csoportok osztálykötés
        nélkül jönnek létre, a típus nélkül pedig mindegyiknél számít a hiányzás.
      </ion-note>
      <div class="ic-sor">
        <ion-select label="Csoport neve *" labelPlacement="stacked" interface="popover" [(ngModel)]="oszlop.nev">
          <ion-select-option *ngFor="let f of fejlecek" [value]="f">{{ f }}</ion-select-option>
        </ion-select>
        <ion-select label="Osztálybontás" labelPlacement="stacked" interface="popover" [(ngModel)]="oszlop.osztaly">
          <ion-select-option value="">—</ion-select-option>
          <ion-select-option *ngFor="let f of fejlecek" [value]="f">{{ f }}</ion-select-option>
        </ion-select>
        <ion-select label="Csoporttípus" labelPlacement="stacked" interface="popover" [(ngModel)]="oszlop.tipus">
          <ion-select-option value="">—</ion-select-option>
          <ion-select-option *ngFor="let f of fejlecek" [value]="f">{{ f }}</ion-select-option>
        </ion-select>
        <ion-select label="Tanév" labelPlacement="stacked" interface="popover" [(ngModel)]="oszlop.tanev">
          <ion-select-option value="">—</ion-select-option>
          <ion-select-option *ngFor="let f of fejlecek" [value]="f">{{ f }}</ion-select-option>
        </ion-select>
        <ion-input label="Tanév felülírása" labelPlacement="stacked" type="number" placeholder="a fájlból"
                   [(ngModel)]="evKezi"></ion-input>
      </div>
      <ion-button color="primary" [disabled]="!oszlop.nev || elemzesFut" (click)="elemez()">
        <ion-icon slot="start" name="search-outline"></ion-icon>
        {{ elemzesFut ? 'Elemzés…' : 'Elemzés (' + kuldhetoSorok.length + ' csoport)' }}
      </ion-button>
    </div>

    <!-- 3. Elemzés -->
    <ng-container *ngIf="elemzes">
      <div class="ic-lepes">
        <h3><span class="ic-szam">3</span> Amit találtunk — <b>{{ elemzes.ev }}</b>-es tanév</h3>

        <ion-note color="warning" class="ic-sugo" *ngIf="elemzes.tobb_tanev">
          A fájlban <b>több tanév</b> szerepel ({{ elemzes.tobb_tanev.join(', ') }}). Csak a(z)
          <b>{{ elemzes.ev }}</b>-essel dolgozunk — ha másikra van szükség, írd be a
          „Tanév felülírása" mezőbe.
        </ion-note>

        <div class="ic-osszegzo">
          <div class="ic-kartya"><b>{{ elemzes.osszegzes.uj }}</b><span>új csoport</span></div>
          <div class="ic-kartya"><b>{{ elemzes.osszegzes.letezik }}</b><span>már létezik</span></div>
          <div class="ic-kartya"><b>{{ elemzes.osszegzes.osztaly_parositva }}</b><span>osztálykötés</span></div>
          <div class="ic-kartya" [class.gond]="elemzes.osszegzes.osztaly_ismeretlen">
            <b>{{ elemzes.osszegzes.osztaly_ismeretlen }}</b><span>ismeretlen osztály</span></div>
          <div class="ic-kartya"><b>{{ elemzes.osszegzes.meglevo_db }}</b><span>meglévő csoport</span></div>
          <div class="ic-kartya" [class.gond]="elemzes.osszegzes.nem_szereplo_db">
            <b>{{ elemzes.osszegzes.nem_szereplo_db }}</b><span>nincs a fájlban</span></div>
        </div>
      </div>

      <!-- 4. Átnevezés -->
      <div class="ic-lepes" *ngIf="elemzes.meglevok?.length">
        <h3><span class="ic-szam">4</span> Átnevezés — törlés helyett</h3>
        <ion-note color="medium" class="ic-sugo">
          Ha csak a <b>nevek</b> romlottak el, ez a helyes út. Az átnevezésnél a csoport
          <b>azonosítója marad</b>, tehát az <b>órarend</b>, a tantárgyfelosztás és a
          meglévő tagságok a helyükön maradnak. Törlés + újralétrehozás után az egész
          órarendet újra fel kellene vinni, mert az új csoport új azonosítót kapna.<br>
          A javaslatot a közös szavak aránya adja — <b>elfogadni neked kell</b>.
        </ion-note>

        <div class="ic-gombsor">
          <ion-button size="small" fill="outline" (click)="javaslatokatElfogad(0.5)">
            Javaslatok elfogadása (50% felett)
          </ion-button>
          <ion-button size="small" fill="clear" color="medium" (click)="parositastTorol()"
                      [disabled]="!parositasDb">Párosítások törlése</ion-button>
          <span class="ic-osszes" *ngIf="parositasDb"><b>{{ parositasDb }}</b> csoport lesz átnevezve</span>
        </div>

        <table class="ic-tabla">
          <thead>
            <tr>
              <th>Meglévő csoport</th>
              <th>Kötődés</th>
              <th>Javaslat</th>
              <th>Átnevezés erre</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let c of elemzes.meglevok" [class.ic-fajlban]="c.fajlban">
              <td>
                {{ c.name }}
                <span class="ic-jel ok" *ngIf="c.fajlban">a fájlban is</span>
              </td>
              <td class="ic-kotodes">
                <span *ngIf="c.tag">{{ c.tag }} tanuló</span>
                <span *ngIf="c.oszt">{{ c.oszt }} osztálykötés</span>
                <span class="figy" *ngIf="c.ora">{{ c.ora }} órarendi óra</span>
                <span class="figy" *ngIf="c.ttf">{{ c.ttf }} TTF-sor</span>
                <span class="ic-halvany" *ngIf="!c.tag && !c.oszt && !c.ora && !c.ttf">üres</span>
              </td>
              <td class="ic-javaslat">
                <ng-container *ngIf="c.javaslat">
                  {{ c.javaslat.nev }}
                  <span class="ic-pont" [class.eros]="c.javaslat.pont >= 0.5">{{ szazalek(c.javaslat.pont) }}%</span>
                </ng-container>
                <span class="ic-halvany" *ngIf="!c.javaslat && !c.fajlban">nincs hasonló</span>
                <span class="ic-halvany" *ngIf="c.fajlban">—</span>
              </td>
              <td>
                <ion-select interface="popover" placeholder="nem nevezem át" [(ngModel)]="parositas[c.id]">
                  <ion-select-option [value]="''">nem nevezem át</ion-select-option>
                  <ion-select-option *ngFor="let r of szabadSorok(parositas[c.id])" [value]="r.kulcs">
                    {{ r.nev }}
                  </ion-select-option>
                </ion-select>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- 5. Törlés -->
      <div class="ic-lepes" *ngIf="elemzes.meglevok?.length">
        <h3><span class="ic-szam">5</span> Törlés — külön döntés</h3>
        <ion-note color="medium" class="ic-sugo">
          Egy csoport törlése nem áll meg a csoportnál: viszi a <b>tagságokat</b>, az
          osztálykötést és a <b>tantárgyfelosztás sorait</b>, az órarendi órákat pedig
          leválasztja róla (az óra megmarad, csak osztályszintűvé válik). Amihez óra vagy
          TTF-sor tartozik, azt kényszerítés nélkül <b>nem bántjuk</b>.
        </ion-note>
        <ion-radio-group [(ngModel)]="torles">
          <ion-radio value="nincs" labelPlacement="end">Nem törlök semmit</ion-radio><br>
          <ion-radio value="nem_szereplo" labelPlacement="end">
            Ami a fájlban nincs benne ({{ elemzes.osszegzes.nem_szereplo_db }} csoport)
          </ion-radio><br>
          <ion-radio value="mind" labelPlacement="end">
            A tanév MINDEN csoportja ({{ elemzes.osszegzes.meglevo_db }})
          </ion-radio>
        </ion-radio-group>

        <div class="ic-figyelmezteto" *ngIf="torlendo.db">
          <b>{{ torlendo.db }}</b> csoport törlődne.
          <ng-container *ngIf="torlendo.akadalyos">
            Ebből <b>{{ torlendo.akadalyos }}</b> órarendi órát vagy tantárgyfelosztás-sort is érint.
          </ng-container>
          <div *ngIf="torlendo.akadalyos">
            <ion-checkbox labelPlacement="end" [(ngModel)]="kenyszer">
              Ezeket is töröljem (az órák leválnak a csoportról, a TTF-sorok elvesznek)
            </ion-checkbox>
          </div>
        </div>
      </div>

      <!-- 6. Végrehajtás -->
      <div class="ic-lepes">
        <h3><span class="ic-szam">6</span> Végrehajtás</h3>
        <ion-button color="primary" [disabled]="fut" (click)="vegrehajt()">
          <ion-icon slot="start" name="play-outline"></ion-icon>
          {{ fut ? 'Fut…' : 'Import indítása' }}
        </ion-button>
      </div>

      <!-- Fájlsorok -->
      <div class="ic-lepes" *ngIf="elemzes.sorok?.length">
        <h3>A fájl sorai</h3>
        <table class="ic-tabla">
          <thead>
            <tr><th>Csoport</th><th>Állapot</th><th>Osztálybontás</th><th>Hiányzás</th></tr>
          </thead>
          <tbody>
            <tr *ngFor="let r of elemzes.sorok">
              <td>{{ r.nev }}</td>
              <td>
                <span class="ic-jel" [class.ok]="r.allapot === 'letezik'"
                      [class.uj]="r.allapot === 'uj'"
                      [class.gond]="r.allapot === 'ismetlodik'">{{ r.allapot }}</span>
              </td>
              <td>
                <span *ngIf="r.osztaly_id">{{ r.osztaly_szoveg }}</span>
                <span class="ic-hasonlo" *ngIf="r.osztaly_hiba">{{ r.osztaly_hiba }}</span>
                <span class="ic-halvany" *ngIf="!r.osztaly_id && !r.osztaly_hiba">nincs</span>
              </td>
              <td>
                <span *ngIf="r.hianyzas_szamit">számít</span>
                <span class="ic-halvany" *ngIf="!r.hianyzas_szamit">nem számít ({{ r.tipus }})</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>

    <!-- Eredmény -->
    <div class="ic-lepes" *ngIf="eredmeny">
      <h3>Eredmény</h3>
      <div class="ic-osszegzo">
        <div class="ic-kartya"><b>{{ eredmeny.atnevezve }}</b><span>átnevezve</span></div>
        <div class="ic-kartya"><b>{{ eredmeny.letrehozva }}</b><span>létrehozva</span></div>
        <div class="ic-kartya"><b>{{ eredmeny.frissitve }}</b><span>frissítve</span></div>
        <div class="ic-kartya" [class.gond]="eredmeny.torolve"><b>{{ eredmeny.torolve }}</b><span>törölve</span></div>
        <div class="ic-kartya"><b>{{ eredmeny.osztaly_kotes }}</b><span>osztálykötés</span></div>
        <div class="ic-kartya" [class.gond]="eredmeny.levalasztott_ora">
          <b>{{ eredmeny.levalasztott_ora }}</b><span>leválasztott óra</span></div>
      </div>
      <div class="ic-hasonlo" *ngFor="let x of eredmeny.atnevezes_kihagyva">
        Átnevezés kimaradt — {{ x.nev }}: {{ x.ok }}
      </div>
      <div class="ic-hasonlo" *ngFor="let x of eredmeny.torles_kihagyva">
        Törlés kimaradt — {{ x.nev }}: {{ x.ok }}
      </div>
      <div class="ic-hasonlo" *ngFor="let x of eredmeny.osztaly_ismeretlen">
        Osztálykötés kimaradt — {{ x.nev }}: {{ x.ok }}
      </div>
    </div>

    <div class="ic-lab">
      <div class="ic-lab-szoveg">
        A <b>tanulókat</b> nem ez a képernyő sorolja be — arra a
        <b>Csoporttagság</b> import való, a „Csoportba járó tanulók" listával.
      </div>
    </div>
  </ion-card-content>
</ion-card>

<!--  ══ CSOPORT–TANTÁRGY KÖTÉS a tantárgyfelosztásból ══  -->
<ion-card>
  <ion-card-header>
    <ion-card-title>Csoport–tantárgy kötés</ion-card-title>
    <ion-card-subtitle>A tantárgyfelosztás exportjából: melyik csoport melyik tantárgyhoz tartozik</ion-card-subtitle>
  </ion-card-header>

  <ion-card-content>
    <ion-note color="medium" class="ic-bevezeto">
      Egy bontott csoporthoz jellemzően <b>egy</b> tantárgy tartozik, és ezt a rendszer több
      helyen használja: az órarendben csoportot választva magától beáll a tantárgy, az
      értékelés-képernyő pedig tantárgy nélkül el sem indul. Egyesével felvinni reménytelen —
      a <b>KRÉTA tantárgyfelosztás-exportja</b> viszont soronként pont ezt tartalmazza.<br>
      <b>Ez kötés-import, nem törzsadat-import:</b> csoportot, osztályt és tantárgyat
      <b>nem hozunk létre</b>. Az osztályra (nem csoportra) mutató sorok kimaradnak — az
      osztály tantárgyait a kerettanterv és a tantárgyfelosztás írja le, nem ez.
    </ion-note>

    <!--  FÁJL NÉLKÜL: a rendszer saját adatából. A csoportok jellemzően rég bent
          vannak, mire kiderül, hogy a kötésük hiányzik — ilyenkor ne kelljen fájlt
          keresni hozzá.  -->
    <div class="ic-sajat">
      <div class="ic-lab-szoveg">
        <b>Fájl nélkül is megy, utólag.</b> A rendszer két saját forrásból tudja, mit tanítanak
        a csoportban: a <b>tantárgyfelosztásból</b> és a csoport <b>eddigi óráiból</b>. Csak ott
        köt, ahol <b>még nincs</b> kötés, és csak ha <b>egyértelmű</b> — a több tantárgyú
        csoportokhoz nem nyúl.
      </div>
      <ion-button size="default" fill="outline" [disabled]="sajatFut" (click)="sajatElemez()">
        {{ sajatFut ? 'Elemzés…' : 'Mit tud a rendszer?' }}
      </ion-button>
    </div>

    <ng-container *ngIf="sajatElemzes">
      <div class="ic-osszegzo">
        <div class="ic-kartya"><b>{{ sajatElemzes.parok.length }}</b><span>most köthető</span></div>
        <div class="ic-kartya"><b>{{ sajatElemzes.mar_kotott }}</b><span>már kötött</span></div>
        <div class="ic-kartya"><b>{{ sajatElemzes.tobb_tantargyu.length }}</b><span>több tantárgyú (kihagyva)</span></div>
        <div class="ic-kartya"><b>{{ sajatElemzes.nincs_adat.length }}</b><span>nincs még adat</span></div>
      </div>
      <table class="ic-tabla" *ngIf="sajatElemzes.parok.length">
        <thead><tr><th>Csoport</th><th>Tantárgy</th><th>Honnan</th></tr></thead>
        <tbody>
          <tr *ngFor="let p of sajatElemzes.parok">
            <td>{{ p.csoport_nev }}</td><td>{{ p.tantargy_nev }}</td><td>{{ p.forras }}</td>
          </tr>
        </tbody>
      </table>
      <div class="ic-lab">
        <ion-button color="primary" [disabled]="sajatFut || !sajatElemzes.parok.length" (click)="sajatVegrehajt()">
          <ion-icon slot="start" name="link-outline"></ion-icon>
          Kötések létrehozása a saját adatból
        </ion-button>
        <span class="ic-halvany" *ngIf="sajatEredmeny"><b>{{ sajatEredmeny.uj }}</b> kötés létrejött.</span>
      </div>
    </ng-container>

    <div class="ic-sor">
      <input type="file" accept=".xlsx,.xls,.csv" (change)="ttfFajlValtozott($event)" />
      <span class="ic-halvany" *ngIf="ttfFajlNev">{{ ttfFajlNev }} — {{ ttfNyers.length }} sor</span>
    </div>

    <div class="ic-sor" *ngIf="ttfFejlecek.length">
      <ion-select label="Osztály / Csoport oszlop" label-placement="stacked" interface="popover"
                  fill="outline" [(ngModel)]="ttfOszlop.cel">
        <ion-select-option *ngFor="let f of ttfFejlecek" [value]="f">{{ f }}</ion-select-option>
      </ion-select>
      <ion-select label="Tantárgy oszlop" label-placement="stacked" interface="popover"
                  fill="outline" [(ngModel)]="ttfOszlop.tantargy">
        <ion-select-option *ngFor="let f of ttfFejlecek" [value]="f">{{ f }}</ion-select-option>
      </ion-select>
      <ion-button size="default" fill="outline" [disabled]="ttfElemzesFut" (click)="ttfElemez()">
        {{ ttfElemzesFut ? 'Elemzés…' : 'Elemzés' }}
      </ion-button>
      <span class="ic-halvany">tanév: <b>{{ ttfEv }}</b> — a csoport és a tantárgy is tanévhez tartozik</span>
    </div>

    <ng-container *ngIf="ttfElemzes">
      <div class="ic-osszegzo">
        <div class="ic-kartya"><b>{{ ttfElemzes.uj_kotes }}</b><span>új kötés</span></div>
        <div class="ic-kartya"><b>{{ ttfElemzes.mar_megvolt }}</b><span>már megvolt</span></div>
        <div class="ic-kartya"><b>{{ ttfElemzes.erintett_csoport }}</b><span>érintett csoport</span></div>
        <div class="ic-kartya"><b>{{ ttfElemzes.osztaly_sor }}</b><span>osztály-sor (kihagyva)</span></div>
        <div class="ic-kartya" [class.gond]="ttfElemzes.hianyzo_cel.length + ttfElemzes.hianyzo_tantargy.length">
          <b>{{ ttfElemzes.hianyzo_cel.length + ttfElemzes.hianyzo_tantargy.length }}</b><span>nem talált</span>
        </div>
      </div>

      <div class="ic-hasonlo" *ngFor="let x of ttfElemzes.hianyzo_cel">
        Nincs ilyen nevű csoport (és nem is osztály): <b>{{ x.nev }}</b> ({{ x.db }} sor)
      </div>
      <div class="ic-hasonlo" *ngFor="let x of ttfElemzes.hianyzo_tantargy">
        Nincs ilyen nevű tantárgy a {{ ttfElemzes.ev }}-es tanévben: <b>{{ x.nev }}</b> ({{ x.db }} sor)
      </div>

      <ion-note color="medium" class="ic-bevezeto" *ngIf="ttfElemzes.tobb_tantargyu.length">
        <b>{{ ttfElemzes.tobb_tantargyu.length }} csoporthoz több tantárgy tartozik</b> a fájl szerint
        (jellemzően érettségi-előkészítők). Ezeknél a rendszer <b>nem fog</b> egyértelmű tantárgyat
        ajánlani — ez nem hiba, csak tudni kell róla.
      </ion-note>

      <table class="ic-tabla">
        <thead><tr><th>Csoport</th><th>Tantárgy</th><th>Sorok</th><th>Állapot</th></tr></thead>
        <tbody>
          <tr *ngFor="let p of ttfElemzes.parok">
            <td>{{ p.csoport_nev }}</td>
            <td>{{ p.tantargy_nev }}</td>
            <td>{{ p.sorok }}</td>
            <td>{{ p.mar_megvan ? 'már megvolt' : 'új' }}</td>
          </tr>
        </tbody>
      </table>

      <div class="ic-lab">
        <label class="ic-kapcs">
          <input type="checkbox" [(ngModel)]="ttfCsakFajl" />
          <b>A fájl legyen a mérvadó</b> — az érintett csoportok fájlban nem szereplő kötéseit töröljük
        </label>
        <ion-button color="primary" [disabled]="ttfFut || !ttfElemzes.parok.length" (click)="ttfVegrehajt()">
          <ion-icon slot="start" name="link-outline"></ion-icon>
          {{ ttfFut ? 'Import…' : 'Kötések létrehozása' }}
        </ion-button>
      </div>

      <div class="ic-eredmeny" *ngIf="ttfEredmeny">
        <b>{{ ttfEredmeny.uj }}</b> új kötés · <b>{{ ttfEredmeny.mar_megvolt }}</b> már megvolt
        <span *ngIf="ttfEredmeny.torolt"> · <b>{{ ttfEredmeny.torolt }}</b> törölve</span>
      </div>
    </ng-container>
  </ion-card-content>
</ion-card>
